import * as React from "react";
import { styled } from "@mui/material";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const base = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 501,
	height: 307,
	fill: "none",
	viewBox: "0 0 501 307",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#FBFBFB",
			d: "m6.56 209.3 3.02 30.24c.64 6.4 5.96 11.3 12.39 11.4l421.2 7.24c11.59.2 17.34-13.96 8.9-21.9l-107.1-100.63a6.78 6.78 0 0 0-8.61-.55 6.77 6.77 0 0 1-7.66.2l-44.18-28.64a12.67 12.67 0 0 1-5.69-12.16l1.63-13.3a12.67 12.67 0 0 0-4.88-11.59l-17.6-13.47a12.67 12.67 0 0 0-15.98.47L220.96 74.8a12.68 12.68 0 0 1-4.07 2.36L164.8 95.52c-2.55.9-4.74 2.58-6.26 4.82l-18.75 27.57a12.66 12.66 0 0 1-10.23 5.55l-20.92.4c-2.48.05-4.88.82-6.92 2.22L12 197.6a12.67 12.67 0 0 0-5.44 11.7Z"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_15352_31293",
			width: 340,
			height: 208,
			x: 35,
			y: 24,
			maskUnits: "userSpaceOnUse",
			style: { maskType: "alpha" },
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#F5F5F5",
				d: "m35.32 182.61 2.53 48.62 336.76-21.5-74.84-105.78-6.65 6.2-41.96-33.9 3.47-28.35-24.08-23.22-24.72 27.21-46.2 22.01-20.39 36.97-24.51 1.42-79.41 70.32Z"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_15352_31293)",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#EDF1F8",
				d: "m92.5 186.6-24.86-18.22c-4.1-3-6.68-7.84-5.35-12.74 12-44.42 114.08-118.06 171.19-148.33a15.25 15.25 0 0 1 18.63 3.64l13.19 15.12a15.83 15.83 0 0 1-3.43 23.77l-40.45 25.72a15.83 15.83 0 0 0-5.34 21.04l22.88 41.23a8.03 8.03 0 0 1-11.7 10.44l-11.95-8.53a8.36 8.36 0 0 0-9.18-.36 8.37 8.37 0 0 1-8.82-.12l-17.26-11.05a13.52 13.52 0 0 0-19.65 5.89 13.52 13.52 0 0 1-3.52 4.74l-7.23 6.23a8.48 8.48 0 0 1-6.57 2 8.48 8.48 0 0 0-9.2 10.7l1.56 5.55a12.32 12.32 0 0 1-6.25 14.29l-20.11 10.3a15.83 15.83 0 0 1-16.58-1.32Z"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#12453F",
			d: "m15.44 170.47 2.98-4.66c.2-.33.7-.28.84.09l2.99 8.25c.1.31-.2.6-.5.47a.37.37 0 0 0-.47.52l3.06 4.97c.2.31-.03.71-.4.71h-1.39c-.37 0-.6.42-.4.73l2.95 4.54a.47.47 0 0 1-.54.7l-.7-.22a.47.47 0 0 0-.54.72l3.67 5.34c.29.41-.2.93-.63.67l-.06-.04c-.41-.25-.89.22-.65.64l3.33 5.95a.47.47 0 0 1-.57.68l-2.43-.87a.47.47 0 0 0-.57.68L29 206.6a.47.47 0 0 1-.56.68l-7.16-2.34a.47.47 0 0 0-.62.44v1.8c0 .47-.6.66-.86.28L18.1 205a.47.47 0 0 0-.5-.2l-4.9 1.12a.35.35 0 0 1-.37-.52.35.35 0 0 0-.35-.53l-5.62 1a.47.47 0 0 1-.43-.78l6.11-6.8a.47.47 0 0 0-.35-.78h-3.1a.47.47 0 0 1-.33-.81l3.65-3.54c.3-.3.1-.81-.33-.81h-1.1a.47.47 0 0 1-.4-.72l2.24-3.73a.47.47 0 0 0-.4-.71h-1.26a.47.47 0 0 1-.36-.78l4.04-4.81a.47.47 0 0 0-.36-.78h-.38c-.37 0-.6-.4-.4-.72l3.02-4.85a.47.47 0 0 0-.44-.72l-.23.02a.47.47 0 0 1-.4-.77l1.46-1.82a.47.47 0 0 0-.37-.77h-.4a.47.47 0 0 1-.39-.72Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#000",
			d: "m18.25 179.45-1.38 31.3h2.75l-1.38-31.3Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#000",
			d: "m21.69 189.08-4.13 5.16h1.2l2.93-5.16Zm-7.4 4.99 4.3 3.1-1.2 1.54-3.1-4.64Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "m15.96 169.27 2.45-3.52c.22-.31.7-.25.83.11l.55 1.55.48 1.27c.03.07.04.14.03.21l-.05.46a.47.47 0 0 1-.84.25l-.32-.4a.47.47 0 0 0-.7-.04l-.23.23a.48.48 0 0 0-.12.2l-.1.32a.47.47 0 0 1-.78.2l-.26-.26a.37.37 0 0 0-.45-.06c-.34.2-.72-.2-.5-.52Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#4FA79D",
			d: "m32.37 183.55-2.6-4.06a.47.47 0 0 0-.84.09l-2.67 7.37c-.1.28.19.54.45.42.3-.14.6.2.43.48l-2.72 4.41c-.2.32.03.72.4.72h1.09c.37 0 .6.42.4.73l-2.55 3.92c-.24.37.11.84.54.7l.39-.12c.43-.13.78.35.53.72L22 203.62c-.27.38.18.85.58.62.38-.23.82.19.6.58l-2.94 5.25c-.22.38.16.82.57.68l1.96-.7c.42-.16.79.29.57.67l-3.11 5.45c-.21.37.15.81.56.68l6.3-2.06c.3-.1.62.13.62.45v1.42c0 .46.6.65.85.27l1.45-2.08a.5.5 0 0 1 .5-.2l4.38 1.01c.28.06.49-.23.34-.47a.31.31 0 0 1 .32-.48l4.95.88c.44.08.73-.44.43-.78l-5.37-5.96a.47.47 0 0 1 .36-.8h2.59c.42 0 .63-.5.33-.8l-3.15-3.04c-.3-.3-.1-.81.33-.81h.8c.37 0 .6-.4.4-.72l-1.93-3.23a.47.47 0 0 1 .4-.72h.95c.4 0 .62-.47.37-.77l-3.53-4.2a.47.47 0 0 1 .37-.78H34c.37 0 .6-.4.4-.72l-2.64-4.24a.47.47 0 0 1 .44-.72c.42.03.67-.44.41-.76l-1.2-1.5a.47.47 0 0 1 .38-.76h.17c.38 0 .6-.42.4-.73Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#031839",
			d: "m29.88 191.43 1.25 28.29h-2.5l1.25-28.3Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#031839",
			d: "m26.77 200.13 3.73 4.66h-1.08l-2.65-4.66Zm6.69 4.51-3.89 2.8 1.09 1.4 2.8-4.2Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#354661",
			d: "m40.88 172.8 3.03-4.73c.2-.3.66-.28.82.06l3.08 6.44c.1.2.04.43-.13.57l-1.28 1.05a.47.47 0 0 0-.1.61l3.45 5.62c.2.32-.03.72-.4.72h-1.37c-.38 0-.6.41-.4.73l2.93 4.51a.47.47 0 0 1-.54.71l-.7-.22a.47.47 0 0 0-.53.72l3.66 5.31c.28.42-.2.94-.63.67l-.05-.03c-.42-.24-.9.22-.66.64l3.32 5.93a.47.47 0 0 1-.57.67l-2.41-.86a.47.47 0 0 0-.57.68l3.56 6.24a.47.47 0 0 1-.55.68l-6.9-2.25a.47.47 0 0 0-.59.58l.15.46c.13.44-.37.8-.74.52l-2.25-1.71c-.11-.09-.25-.12-.39-.09l-4.97 1.14a.35.35 0 0 1-.38-.52.35.35 0 0 0-.35-.53l-5.6 1a.47.47 0 0 1-.43-.79l6.1-6.77a.47.47 0 0 0-.36-.78h-3.1a.47.47 0 0 1-.32-.81l3.64-3.53c.3-.3.1-.8-.33-.8h-1.09a.47.47 0 0 1-.4-.72l2.23-3.72a.47.47 0 0 0-.4-.71H36.1a.47.47 0 0 1-.36-.78l4.02-4.8a.47.47 0 0 0-.36-.77h-.37c-.37 0-.6-.4-.4-.72l3-4.84a.47.47 0 0 0-.43-.72l-.22.02a.47.47 0 0 1-.4-.76l1.45-1.82a.47.47 0 0 0-.37-.77h-.39a.47.47 0 0 1-.4-.72Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#031839",
			d: "m44.2 181.42 1.36 31.22h-2.74l1.37-31.22Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#031839",
			d: "m40.76 191.03 4.12 5.15h-1.2l-2.92-5.15Zm7.38 4.97-4.3 3.1 1.2 1.53 3.1-4.63Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "m41.4 171.61 2.5-3.59c.21-.3.66-.26.82.06l2.02 4.17a.48.48 0 0 1-.48.68l-.3-.04a.47.47 0 0 0-.5.34l-.09.27a.47.47 0 0 1-.86.1l-.64-1.14a.3.3 0 0 0-.56.06.3.3 0 0 1-.51.13l-.46-.46a.37.37 0 0 0-.45-.05c-.34.2-.72-.2-.49-.53Zm-5.82 17.1 3.52-4.18c.33-.38.99-.06.9.44-.15.9-.29 1.95-.27 2.8.02.71.15 1.58.3 2.34.06.32-.41.52-.59.24a.29.29 0 0 0-.47 0l-.27.37a.47.47 0 0 1-.85-.28v-.48a.47.47 0 0 0-.48-.47h-1.43a.47.47 0 0 1-.36-.78Z"
		})
	]
});
const SvgMountainDesktop = styled(base)({});
export default SvgMountainDesktop;
